export default __webpack_public_path__ + "static/media/nav.00fdaf72.less";